import './CustomerHistoryContainer.scss';
import Component from './CustomerHistoryContainer.js';
export default Component;
